import React, { createContext, useContext } from 'react';
import type { UploadStartedInfo } from '../uploader';

export interface AppContextValue {
  errorMessage: string;
  setErrorMessage: (msg: string) => void;
  handleCancelUpload: (uploadId: string, key: string) => void;
  handlePauseUpload: (uploadId: string) => void;
  handleResumeUpload: (uploadId: string) => Promise<void>;
  handleUploadStarted: (info: UploadStartedInfo) => void;
}

const AppContext = createContext<AppContextValue | null>(null);

export const AppProvider = AppContext.Provider;

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
}

/**
 * Safe version of useAppContext that returns null instead of throwing.
 * Use this in routes that may be accessed without authentication (e.g., /preview).
 */
export function useAppContextSafe(): AppContextValue | null {
  return useContext(AppContext);
}
